import React from 'react';
import { MediaMobile, MediaTablet, MediaDesktop } from '../../MediaWrapper';
import { DataProps } from '../common/types';
import { WrapperStoreData } from '../common/WrapperStoreData';
import { CompleteDesktop } from './components/ShopDataCompleteDesktop';
import { CompleteMobile } from './components/ShopDataCompleteMobile';
import { CompleteTablet } from './components/ShopDataCompleteTablet';
import styles from './style.module.css';

interface Props {
  dataAddress: DataProps;
  handleToggleModalComment: () => void;
  handleToggleRatingModal: () => void;
  services: any;
  dataValue?: string | any;
}

export const CompleteShopData = ({
  dataAddress,
  handleToggleModalComment,
  handleToggleRatingModal,
  services,
  dataValue,
}: Props) => {
  if (!dataAddress) {
    return null;
  }

  return (
    <WrapperStoreData type="complete" className={styles.wrapperStoreData}>
      <MediaMobile>
        <CompleteMobile
          dataStore={dataAddress}
          handleToggleModalComment={handleToggleModalComment}
          handleToggleRatingModal={handleToggleRatingModal}
          services={services}
          dataValue={dataValue}
        />
      </MediaMobile>
      <MediaTablet>
        <CompleteTablet
          dataStore={dataAddress}
          handleToggleModalComment={handleToggleModalComment}
          handleToggleRatingModal={handleToggleRatingModal}
          services={services}
          dataValue={dataValue}
        />
      </MediaTablet>
      <MediaDesktop>
        <CompleteDesktop
          dataStore={dataAddress}
          handleToggleModalComment={handleToggleModalComment}
          handleToggleRatingModal={handleToggleRatingModal}
          services={services}
          dataValue={dataValue}
        />
      </MediaDesktop>
    </WrapperStoreData>
  );
};
